import { ComponentPropsWithoutRef } from 'react';
import { useQuery } from 'react-query';
import classNames from 'classnames';
import { ActionIcon, CustomIcon, FavouriteIcon, HomeIcon } from '@tymbe/ui-icons';
import moment from 'moment';
import { queryFn } from './utils';

interface PersonCardProps extends ComponentPropsWithoutRef<'div'> {
  personId: string | number;
  frogie?: boolean;
}

const PersonCard = ({className, personId, frogie=false}: PersonCardProps) => {
  const { data: person } = useQuery({
    queryKey: ['person', personId] as const,
    queryFn,
    enabled: !!personId,
  });

  const { data } = useQuery({
    queryKey: ['person-data', personId, { $modify: 'attendanceRate' }] as const,
    queryFn,
    enabled: !!personId,
  });

  return (
    <div className={classNames('flex gap-2 items-center', className)}>
      <div className="flex rounded-full size-6 justify-center items-center uppercase bg-white text-caption-xl">SJ</div>
      <div className="flex flex-col grow">
        <span>{person?.first_name} {person?.last_name}</span>
        <div className="flex text-caption-xl font-normal *:after:content-['•'] *:after:mx-1 *:after:text-secondary-transparent-16 [&>*:last-child]:after:hidden">
          <div className="flex items-center align-middle">
            <FavouriteIcon name={data?.gender === 'male' ? 'male' : 'female'} className="size-4 text-secondary-transparent-48" />
            <div className="h-4 align-middle leading-4">{moment().diff(data?.birthdate, 'years')}</div>
          </div>
          <div className="h-4 align-middle leading-4">{person?.id}</div>
          {frogie && <CustomIcon name="rookie" className="size-4 text-secondary-transparent-48" />}
        </div>
      </div>
      <div className="flex items-center align-middle gap-1">
        <HomeIcon name="electric_bolt" className="size-3 text-secondary-400" />
        <div className="h-4 align-middle text-caption-xl font-medium w-8">{getPercent(data?.attendanceCount, data?.applicationCount)}%</div>
      </div>
      <div className="flex items-center align-middle gap-1">
        <ActionIcon name="thumb_up" className="size-3 text-secondary-400" />
        <div className="h-4 align-middle text-caption-xl font-medium w-8">{data?.job_evaluation || 0}%</div>
      </div>
    </div>
  )
}

const getPercent = (value?: number | string, total?: number | string) => {
  if (!value || !total) return 0;
  const numValue = Number(value);
  const numTotal = Number(total);

  if (numTotal === 0) return 0;

  return Math.round((numValue / numTotal) * 100);
}

export default PersonCard;
